import { Breadcrumbs, Link } from "@mui/material";

export default function RecordableBreadcrumbs() {
  return (
    <Breadcrumbs separator="•" aria-label="breadcrumb" sx={{ marginBottom: 2 }}>
      <Link color="inherit">Orders</Link>
      <Link color="inherit">Recordables</Link>
      <Link color="text.primary">List</Link>
    </Breadcrumbs>
  );
}
